<template>
  <section
    :class="{ 'luck-draw': true, [`luck-draw-${type}`]: true }"
    :style="{
      backgroundColor: activityInfo.special_info.theme_color,
    }"
  >
    <div id="custom-style" ref="styleRef"></div>
    <div class="show-prize-btn" @click="scrollToPrize">奖品列表</div>
    <component
      :is="luckDrawComponent"
      :type="type"
      :beforeDraw="beforeDraw"
      :afterDraw="afterDraw"
      :remainingTimes="remainingTimes"
      :activityReward="activityReward"
      :openPrizePopup="openPrizePopup"
      :activityInfo="activityInfo"
      :prizeRecord="prizeRecord"
      :toUse="toUse"
      :toGet="toGet"
      :prizeConfigList="prizeConfigList"
    />
    <section class="loops-swipe">
      <div class="swipe-gift">
        <svg-icon class="icon-naba" iconClass="naba" />
        中奖播报：
      </div>
      <van-swipe
        class="swipe"
        :autoplay="3000"
        :show-indicators="false"
        height="27px"
        :vertical="true"
      >
        <van-swipe-item v-for="(item, idx) in loops" :key="idx">
          {{ item.text }}
        </van-swipe-item>
      </van-swipe>
    </section>
    <div
      class="activity-banner"
      v-if="activityInfo.special_info.activity_banner"
    >
      <van-image
        :src="activityInfo.special_info.activity_banner"
        @click="handleActivityBannerClick"
      />
    </div>
    <!-- 奖品图片 -->
    <prizeList
      :prizeRecord="prizeRecord"
      :type="type"
      :activityInfo="activityInfo"
      ref="prizeListRef"
      :activityName="activityName"
    />
    <div class="prize-result" v-if="activityInfo.special_info.prize_list_img">
      <div class="prize-result-bg">
        <div class="scroll-image-box">
          <div class="scroll-image-inner" ref="scrollImage">
            <van-image
              @load="imgLoad"
              class="scroll-image"
              :src="activityInfo.special_info.prize_list_img"
            />
            <van-image
              class="scroll-image"
              :src="activityInfo.special_info.prize_list_img"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="luck-draw-rule">
      <div class="luck-rule-inner">
        <div class="draw-rules-title">活动规则：</div>
        <div class="draw-rules-text" v-html="activityInfo.rules"></div>
      </div>
    </div>
    <open-member-dialog page="activity" />
  </section>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import PrizeList from "./PrizeList";
import Blindbox from "./Blindbox";
import LuckyTurn from "./LuckyTurn";
import LuckyGrid from "./LuckyGrid";
import MidAutumn from "./MidAutumn";
import Qiyuan from "./Qiyuan";
import OpenMemberDialog from "@/components/OpenMemberDialog";
import SlotMachine from "./SlotMachine";
import Drawlot from "./Drawlot";
import Egg from "./Egg";
import Fudai from "./Fudai";
import Scratch from "./Scratchcard";
import { storage } from "@/utils";
import {
  getAtivityRecord,
  handleActivityReward,
  handleKeepActivityReward,
} from "@/apis/luckdraw";
import Vue from "vue";
import store from "@/store";
import ans from "@/utils/ans";
import animateScrollTo from "animated-scroll-to";
import { queryLoopData } from "@/apis/home";
const vm = Vue.prototype;

export default defineComponent({
  inheritAttrs: false,
  props: {
    activityInfo: Object,
    fetchActivityInfo: Function,
    prizeRecord: Array,
    activityName: String,
  },
  components: {
    PrizeList,
    Blindbox,
    LuckyTurn,
    SlotMachine,
    LuckyGrid,
    MidAutumn,
    Drawlot,
    Scratch,
    Egg,
    Qiyuan,
    OpenMemberDialog,
    Fudai,
  },
  setup({ activityInfo, fetchActivityInfo, activityName }) {
    const type = computed(() => activityInfo.special_info.type);
    const styleRef = ref(null);
    const prizeListRef = ref(null);
    const show = ref(false);
    const activityReward = reactive({});
    const userInfo = store.state.userInfo;
    const loops = ref([]);
    const scrollImage = ref(null);
    const luckDrawComponent = computed(() => {
      const Comp = {
        blindbox: "Blindbox",
        lucky: "LuckyTurn",
        luckyGrid: "LuckyGrid",
        midAutumn: "MidAutumn",
        drawlot: "Drawlot",
        scratch: "Scratch",
        slotMachine: "SlotMachine",
        egg: "Egg",
        qiyuan: "Qiyuan",
        fudai: "Fudai",
      };
      return Comp[type.value];
    });

    // 剩余次数
    const remainingTimes = computed(() => {
      if (activityInfo.special_info.member_open_activity) {
        return activityInfo.keepAcitvityTimes;
      }
      return (
        activityInfo.special_info.times_per_day - activityInfo.amt_of_today
      );
    });

    const prizeConfigList = computed(() => {
      const goods_choice = activityInfo.special_info.goods_choice || {};
      return Object.entries(goods_choice).map(([k, v], index) => {
        return {
          ...v,
          item_code: k,
        };
      });
    });

    onMounted(async () => {
      const res = await queryLoopData({
        activity_type: store.state.namespace + "-luckdraw",
      });
      loops.value = res.data.data_list;
    });

    const beforeDraw = async (showLoading) => {
      ans.track("before_blindbox_benefit_click", {
        activityName,
      });
      let token = storage.getItem("token");
      if (!token) {
        vm.$toast("您还未登录，请先登录~");
        return;
      }
      // 针对会员权益活动 结束活动后可以继续参与
      if (
        !activityInfo.is_active &&
        !activityInfo.special_info.member_open_activity
      ) {
        vm.$toast("活动已结束");
        return;
      }
      //如果不是会员 并且 非会员不能参与
      if (!userInfo.is_member) {
        const un_index = vm.$getConfigValue("UN_INDEX");
        if (un_index) {
          vm.$confirm({
            message: "您还不是会员，开通会员即可享受特惠权益",
            cancelButtonText: "我再想想",
            confirmButtonText: "去开通",
          }).then(() => {
            location.href = un_index;
          });
        } else {
          vm.$toast("本活动仅限VIP会员参加，请先开通会员~");
          if (store.state.isMiniProgram) {
            setTimeout(() => {
              wx.miniProgram.navigateBack({
                delta: 1,
              });
            }, 3000);
          }
        }
        return;
      }
      if (!remainingTimes.value) {
        vm.$toast(activityInfo.special_info.no_times_tips || "没有次数了哦~");
        return;
      }
      let loading;
      if (showLoading) {
        loading = vm.$loading();
      }
      try {
        const res = await handleActivityReward({
          activity_name: activityName,
          source: "会员权益",
          reward_platform: activityInfo.reward_platform,
          hideMsg: true,
        });
        Object.assign(activityReward, res.data);
        ans.track("blindbox_benefit_click", {
          item_code: res.data.item_code,
        });
        // 自动激活奖品,ps只支持手机号权益充值，不能配置其他充值账号类型的sku
        if (
          res.data.status === 7 &&
          activityInfo.special_info.auto_activate_prize
        ) {
          const activityRecords = await getAtivityRecord({
            activity_name: activityName,
          });
          const record = activityRecords.data.find(
            (item) => item.extra_info?.order_number === res.data.order_number
          );
          if (record) {
            const fn =
              activityInfo.object === "keep"
                ? handleKeepActivityReward
                : handleActivityReward;
            await fn({
              top_up_account: userInfo.user_phone,
              activity_name: activityName,
              source: "会员权益",
              record_id: record.record_id,
              reward_platform: activityInfo.reward_platform,
              order_number: res.data.order_number,
            });
          }
        }
        return res.data;
      } catch (e) {
        vm.$toast(e?.msg || "活动太火爆了，请稍后再试");
        Promise.reject();
      } finally {
        loading && loading.clear();
      }
    };
    const afterDraw = async () => {
      await Promise.all([fetchActivityInfo()]);
    };

    const openPrizePopup = () => {
      prizeListRef.value.open();
    };

    const toUse = (item) => {
      prizeListRef.value.toUse(item);
    };

    const toGet = (item) => {
      prizeListRef.value.toGet(item);
    };

    const scrollToPrize = () => {
      if (type.value === "egg") {
        prizeListRef.value.open();
      } else {
        const el = document.querySelector(".prize-result");
        el.style.display = "block";
        animateScrollTo(el);
      }
    };

    const handleActivityBannerClick = () => {
      vm.$jumpUrl(activityInfo.special_info.activity_banner_url);
    };

    const imgLoad = () => {
      let scrollSpeed = 1;
      const container = scrollImage.value;
      const width = container.querySelector("img").clientWidth;
      const totalWidth = width;
      if (!container) return;
      let scrollLeft = 0;

      const step = () => {
        scrollLeft += scrollSpeed;
        if (scrollLeft >= totalWidth) {
          scrollLeft = 0; // 回到起点
        }
        container.style.transform = `translateX(-${scrollLeft}px)`;
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    watch(activityInfo, () => {
      if (activityInfo.special_info?.style) {
        document.getElementById(
          "custom-style"
        ).innerHTML = `<style>${activityInfo.special_info.style}</style>`;
      }
    });

    return {
      luckDrawComponent,
      type,
      remainingTimes,
      beforeDraw,
      afterDraw,
      styleRef,
      openPrizePopup,
      prizeListRef,
      toUse,
      toGet,
      activityReward,
      scrollToPrize,
      prizeConfigList,
      loops,
      imgLoad,
      scrollImage,
      handleActivityBannerClick,
      // behavioralVerify,
    };
  },
});
</script>


<style lang="less" scoped>
.luck-draw {
  /deep/ .luck-draw-body {
    position: relative;
  }
  /deep/ .luck-draw-bg {
    min-height: 50vh;
    img {
      width: 100%;
      height: auto;
    }
  }
  /deep/ .luck-draw-component {
    position: absolute;
    top: 33%;
    left: 50%;
    transform: translateX(-50%);
  }
  /deep/ .draw-btn-wrap {
    margin: 0 20px;
  }
}

.luck-draw-rule {
  padding: 10px 12px;
}
.luck-rule-inner {
  border-radius: 10px;
  padding: 15px 10px;
  font-size: 12px;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100%;
}
.draw-rules-title {
  font-size: 14px;
  font-weight: bold;
}
.draw-rules-text {
  line-height: 1.5;
  margin-top: 10px;
  white-space: pre-wrap;
}

.luck-draw-midAutumn,
.luck-draw-drawlot {
  /deep/ .prize-list-btn {
    display: none;
  }
}

.prize-result {
  margin: 20px 12px 0;
  img {
    width: 100%;
  }
}

.show-prize-btn {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 76px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  border-radius: 28px 0 0 28px;
  background: rgba(#01acea, 0.7);
  color: #fff;
  text-align: center;
  z-index: 10;
  padding-left: 10px;
  box-sizing: border-box;
}

.loops-swipe {
  height: 47px;
  padding: 10px 13px;
  box-sizing: border-box;
  background: rgba(#e2d7f8, 0.45);
  border-radius: 8px;
  margin: 10px 15px 26px;
  display: flex;
}
.swipe {
  height: 27px;
}

.van-swipe-item {
  line-height: 27px;
  font-size: 12px;
  color: #fff;
}

.swipe-gift {
  height: 27px;
  color: #fff;
  flex-shrink: 0;
  line-height: 27px;
  display: flex;
  font-weight: bold;
  align-items: center;
  .icon-naba {
    font-size: 20px;
    margin-right: 10px;
  }
}

.prize-result-bg {
  height: 111px;
  background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202502061a9c48e584067.png)
    no-repeat;
  background-size: contain;
  padding-left: 50px;
  padding-top: 8px;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding-right: 14px;
  .scroll-image-box {
    overflow: hidden;
  }
  .prize-result-img {
    height: 95px;
    overflow-x: auto;
    /deep/ img {
      display: block;
      width: 100%;
    }
  }
}
.scroll-image {
  flex-shrink: 0;
}

.scroll-image-inner {
  display: flex;
  height: 95px;
}

.activity-banner {
  padding: 0 12px;
  margin-bottom: 30px;
  image {
    width: 100%;
    height: auto;
  }
}

@keyframes scrollInfintie {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>